import React from 'react'
import Home from './home'
import Cuisine from './Cuisine'
import Searched from './Searched'
import Recipe from './Recipe'
import {Route, Routes, useLocation, Navigate} from "react-router-dom"
import { AnimatePresence } from 'framer-motion'

function Pages() {

  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/cuisine/:type" element={<Cuisine />} />
        <Route path="/searched/:search" element={<Searched />} />
        <Route path="/recipe/:name" element={<Recipe />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AnimatePresence>

  )
}

export default Pages
